export enum NotificationType {
    DataCheckinJob = 'data-checkin',
    Analytics = 'analytics',
}
